import React from "react";
import { Col, Container, Row } from "@dyerlabs/design-system-web-components";
import { Track } from "types";
import Player from "./Player";
import Tracks from "./Tracks";
import { PageHero } from "@dyerlabs/ui-kit-web-components";

export interface MainProps {
  isHost: boolean;
  isPlaying: boolean;
  isReady: boolean;
  track: Track | null;
  tracks: Track[];
  pauseTrack: () => void;
  playTrack: () => void;
  switchTrack: (track: Track) => void;
}

const Main: React.FC<MainProps> = (props) => (
  <React.Fragment>
    <PageHero
      bg="primary"
      title={props.track?.title || ""}
      text={props.track?.artist || ""}
      content={
        <Player
          isHost={props.isHost}
          isReady={props.isReady}
          isPlaying={props.isPlaying}
          track={props.track}
          pauseTrack={props.pauseTrack}
          playTrack={props.playTrack}
        />
      }
      dark
      gradient
    />
    <Container className="mt-5 px-5">
      <Row className="gx-5 justify-content-center">
        <Col lg="8">
          <Tracks tracks={props.tracks} switchTrack={props.switchTrack} />
        </Col>
      </Row>
    </Container>
  </React.Fragment>
);

export default Main;
